// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { formatDateWithAbbvStr, getHourAndMinutesStr, getDateFromString } from 'utils/dateUtils';
import { getGGMapsLink } from 'utils/urlUtils';
import { ffrName } from 'utils/ffrNameUtils';

import type { EventMatchType } from 'types/Event';
import type { CompetitionEquipeType } from 'types/Settings';
import type { RouterProps } from 'types/Router';

export type StateProps = {
  competitionsEquipes: CompetitionEquipeType,
};

type Props = {
  event: EventMatchType,
  hasMargin?: boolean,
  eventList?: boolean,
} & StateProps & RouterProps;

type State = {
  matchLink: ?string,
};

class EventListElementMatch extends Component<Props, State> {
  state = {
    matchLink: null,
  };

  componentDidMount() {
    const {
      competitionsEquipes,
      event: {
        compID,
        matchID,
      },
    } = this.props;

    if (competitionsEquipes && compID && matchID) {
      const matchLink = `${competitionsEquipes[compID].equipe_slug.replace(/\/+$/,'')}/match/${matchID}`;
      this.setState({ matchLink });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { matchLink } = this.state;

    if (matchLink !== nextState.matchLink) {
      return true;
    }

    return false;
  }

  redirectToMatch = () => {
    const {
      history,
    } = this.props;
    const { matchLink } = this.state;

    history.push(`${matchLink || ''}`);
  };

  render() {
    const {
      event: {
        compTag,
        journee,
        localClub,
        visiteurClub,
        localEmbleme,
        visiteurEmbleme,
        startDate,
        address,
        etat,
      },
    } = this.props;

    const locaux = ffrName(localClub);
    const visiteurs = ffrName(visiteurClub);

    let status = etat;
    if (etat === 'Planifiée') {
      if (moment().diff(startDate, 'hours') >= 25) {
        status = 'En attente de retours terrain';
      } else {
        status = 'À venir';
      }
    } else if (etat === 'Terminée' || etat === 'Score validé') {
      status = 'Terminé';
    }
    return (
      <div
        role='button'
        tabIndex={0}
        onClick={this.redirectToMatch}
        className={'box card card--score score-team upcoming'}>
        <div className="card__header">
          <div>
            <span className="ft-h6 ft-up">{compTag}</span>
            <span className="ft-h6">{compTag} — {journee}</span>
          </div>
          <span className="ft-h6 ft-up label">{status}</span>
        </div>
        <div className="card__body">
          <div className="match">
            <div className="match__club">
              <p className="ft-h3 ft-400">
                <span>{locaux}</span>
                <img src={localEmbleme} alt={`Logo ${locaux}`} width="24" height="24" />
              </p>
            </div>
            <div className="match__info">
              <p className="match__time ft-700  ft-up">
                {formatDateWithAbbvStr(getDateFromString(startDate))}
                <br />
                {getHourAndMinutesStr(getDateFromString(startDate))}
              </p>
            </div>
            <div className="match__club">
              <p className="ft-h3 ft-400">
                <img src={visiteurEmbleme} alt={`Logo ${visiteurs}`} width="24" height="24" />
                <span>{visiteurs}</span>
              </p>
            </div>
          </div>
          {address !== "Adresse indisponible pour le moment"
            ? <a
                href={getGGMapsLink(null, address)}
                target="_blank"
                rel="noopener noreferrer"
                title="Voir l'adresse sur Google Map (nouvel onglet)"
                className="event__info mt-3 ft-700">
                <i className="icon icon-place is-inline" />
                {address}
              </a>
            : <p className="event__info mt-3 ft-700">{address}</p>
          }
        </div>
      </div>
    );
  }
}

export default withRouter(EventListElementMatch);
